export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Puzzle-ul este deschis!',
	'Congratulations!': 'Felicitări!',
	'You get it': 'Primesti',
	'You get the task done': 'Îndepliniți sarcina',

	'Show all blocked': 'Afișați toate blocate',

	Author: 'Autor',
	'Reset filters': 'Resetați filtrele',

	Blocked: 'Blocat',
	Unlocked: 'Deblocat',

	Change: 'Schimbare',
	'The student is blocked': 'Studentul este blocat',

	'The student is blocked with a new price':
		'Studentul este blocat cu un nou preț',
	'To unlock this student, go to the "Restore" section':
		'Pentru a debloca acest student, accesați secțiunea „Recuperare”',

	'First month cost': 'Pret pentru 1 luna',

	'Before blocking, you can change the price for the student':
		'Înainte de blocare, puteți modifica prețul pentru student',

	'Block student': 'Blocați elevul',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'AVERTIZARE! După re-salvarea sarcinii, elevii care au finalizat această sarcină vor avea puzzle-ul închis și vor trebui să o facă din nou.',

	"You cannot do homework in the student's platform":
		'Nu puteți face teme pe platforma elevului',

	'Restore the student ?': 'Restabiliți studentul?',
	'Restore the teacher ?': 'Restabiliți profesorul?',
	'Restore the franchise ?': 'Restabiliți franciza?',

	'Transition to 50': 'trecerea la 50',
	'Transition to 100': 'trecerea la 100',

	fifty: 'trecerea la 50',
	hundred: 'trecerea la 100',

	Faces: 'Chipurile',

	Heroes: 'Eroii',
	Clothes: 'Haine',
	Backgrounds: 'Fundaluri',
	Souvenirs: 'Suveniruri',

	'Coming soon': 'Curând',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Wow! Felicitări, ați achiziționat cu succes acest produs.',
	'You can view all your purchases in the "Purchased" section':
		'Puteți vizualiza toate achizițiile dvs. în secțiunea „Achiziționat”.',

	'Your savings': 'Economiile tale',
	'You can spend them on something interesting!':
		'Le poți cheltui pe ceva interesant!',

	'A student with this email address already exists':
		'Utilizatorul cu astfel de e-mail există deja',

	'User with such email already exists':
		'Utilizatorul cu astfel de e-mail există deja',
	'Year of birth': 'Anul nasterii',
	Registration: 'Înregistrare',
	'Surname of parents': 'Numele părinților',
	School: 'Şcoală',
	'Field is required': 'Câmpul este obligatoriu',
	'Select age': 'Selectați vârsta',
	'No such teacher for this year':
		'Nu există un astfel de profesor pentru anul acesta',
	'User with such phone number already exists':
		'Utilizator cu un astfel de număr de telefon există deja',
	'You are successfully registered': 'Sunteți înregistrat cu succes',
	'Max length 20 chars': 'Lungime maximă 20 de caractere',

	'INTERNATIONAL SCHOOL': 'SCOALA INTERNATIONALA',
	'Mental Arithmetic': 'Aritmetica mentala',
	'For children aged 5-14.': 'Pentru copii de 5-14 ani.',
	'Sign up for a trial lesson': 'Înscrie-te pentru o lecție de probă',
	'Parents name': 'Numele părinților',
	'Childs age': 'Varsta copilului',
	Country: 'Țară',
	'Sign up': 'Inscrie-te',
	'Open offer agreement': 'Acord de ofertă deschisă',

	'Participate in online Indigo Olympiad':
		'Participă la Olimpiada Indigo Online',
	Participate: 'Participă',
	export: 'Export',
	match: {
		addition: 'Forsage',
		multiply: 'Îmulțire',
		divide: 'Împărțire',
		abacus_random: 'Abacul Random',
		anzan: 'Anzan',
		negative: 'Cifre  Negative',
		column: 'Coloane',
	},
	'Only task': 'Însărcinare',
	'Back to Lessons': 'Înapoi la lecții',
	'Create Lesson': 'Creare lecție',
	Assign: 'Numiți',
	Home: 'Acasă',
	'To cabinet': 'În cabinet',
	'Create a homework': 'Crează temă pentru acasă',
	January: 'Ianuarie',
	February: 'Februarie',
	March: 'Martie',
	April: 'Aprilie',
	May: 'Mai',
	June: 'Iunie',
	July: 'Iulie',
	August: 'August',
	'Group nickname': 'Denumirea grupei',
	September: 'Septembrie',
	October: 'Octombrie',
	November: 'Noiembrie',
	December: 'Decembrie',
	Overall: 'În general',
	Active: 'Activi',
	'Contract number': 'Număr de contact',
	'For parents': 'Pentru părinți',
	'Choose lessons': 'Alege lecțiile',
	Save: 'Atribuiți',
	Close: 'Închide',
	'Change birthday': 'Schimbă data nașterii',
	Sent: 'Trimis',
	'Choose date': 'Alege data',
	'Include students': 'Includeți elevul',
	'Add service': 'Adaugă opțiune',
	'Create folder': 'Crează o mapă',
	Answer: 'Răspuns',
	Price: 'Preț',
	'Date of creating': 'Data creării',
	Month: 'Lună',
	unpaid: 'Neachitat',
	paid: 'Achitat',
	'Excluded students': 'Elevi blocați',
	'Selected groups': 'Grupe selectate',
	Monday: 'Luni',
	Tuesday: 'Marți',
	Wensday: 'Miercuri',
	Thusday: 'Joi',
	Friday: 'Vineri',
	Saturday: 'Sâmbătă',
	Sunday: 'Duminică',
	Mo: 'L',
	Tu: 'M',
	We: 'Me',
	Th: 'J',
	Fr: 'V',
	Sa: 'S',
	Su: 'D',
	End: 'Sfârșit',
	'Add discount': 'Adaugă reducere',
	Edit: 'Redactare',
	'Parent found': 'Datele părinților',
	'Changes saved': 'Schimbare salvată ',
	'The passwords of the parent and the student should not coincide':
		'Parola părinților nu trebuie să coincidă cu parola copiilor',
	'Prețul pentru regiunea dmv': 'Цена вашего региона установлена как ',
	'and the holder`s reward is': 'Câștigul proprietarului ',
	'regardless of the set price': 'Indiferent de preț',
	'The given password is not unique for this email':
		'Aceasta parolă nu corespunde',
	'Enter a valid email address.': 'Întroduceți corect adresa de email.',
	'The phone number entered is not valid': 'Nr de telefon nu este corect',
	Holiday: 'Sărbători',
	'Working days': 'Zile de lucru',
	Street: 'Strada',
	'Location name': 'Denumirea locației',
	District: 'Regiune',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Aritmetica Mentală - o tehnică de calcul imaginar care dezvoltă rapid abilitățile mintale și inteligența copiilor cu vârsta de la 5 la 14 ani. Procesul de studiu are loc cu ajutorul unui instrument japonez special - Abacul (Soroban). Aritmetica Mentală antrenează concomitent emisfera dreaptă și cea stângă ale creierului, îmbunătățind memoria vizuală, concentrarea, creativitatea, gândirea imaginară a copiilor și tendința lor de a citi rapid.',
	'Field required': 'Câmp obligatoriu',
	'Type of legal activity': 'Datele juriduce',
	'Legal address': 'Adresa juridică',
	'Registration number': 'Nr de înregistrare',
	'Add Group': 'Formarea unei grupe noi',
	'Add Student': 'Adaugă elev',
	Add: 'Adaugă',
	'Add file': 'Adaugă fișier',
	Signin: 'Intrare',
	'Bonus days': 'Bonusul zilei',
	'Bonus weeks': 'Bonusul săptămânii',
	'Are you sure you want to delete?': 'Sunteti sigur că doriți să-l eliminați',
	Delete: 'Eliminați',
	Days: 'Zile',
	Confirm: 'Conformare',
	Cancel: 'Anulare',
	Week: 'Șăptămână',
	Weeks: 'Săptămâni',
	'Group age name': 'Denumirea grupei',
	'Set bonus days': 'Adăugarea bonusurilor zilei ',
	'Default language': 'Fără sunet',
	'With english': 'L-eng',
	'Without english': 'Fără l-eng',
	'Paid status': 'Status online',
	'Not paid': 'Neachitat',
	Turnover: 'Rulaj',
	Block: 'Blocat',
	Blocked: 'Deblocați',
	'On holidays': 'În vacanță',
	Language: 'Limba',
	Discounts: 'Reducere',
	Message: 'Notificare',
	Subject: 'Tema',
	Homework: 'Temă pentru acasă',
	'Homework ': 'Antrenament',
	'Homework on': 'Temă pentru acasă',

	'You need to complete the exercises': 'Îndeplinirea sarcinilor',
	Homework: 'Temă pentru acasă',
	'Invoice for': 'Cont de plată',
	"PJSC CB 'PRIVATBANK' in Kyiv": 'Privat Bank în Kiev',
	Account: 'Cont',
	Supplier: 'Furnizor',
	Buyer: 'Cumpărător',
	'Bank code': 'Cod bancar ',
	'Type phone number or email':
		'Întroduceți numărul de telefon sau adresa de electronică',
	'Type password': 'Întroduceți parola',
	'Forgot password': 'Ați uitat parola',
	'Type your email': 'Întroduceți adresa electronică',
	Send: 'Trimite',
	'Email sent': 'Scrisoare trimisă',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Dacă există un cont cu acest e-mail, vom trimite un mesaj pentru a restabili accesul',
	'Back to the sign in': 'Înapoi',
	'Password or login is not correct': 'Parola sau loghinul incorect',
	'Password recovery': 'Recuperarea parolei',
	'Type your new password here': 'Întroduceți parola nouă',
	'Set new password': 'Recuperarea parolei',
	'Learn more': 'Informație',
	'About Us': 'Despre noi',
	Company: 'Companie',
	Jobs: 'Lucru',
	Press: 'Presa',
	'Terms of Use': 'Modul de utilizare',
	'Privacy Policy': 'Politica de confidențialitate',
	'Need help?': 'Ajutor?',
	'Contact us': 'Contactați-ne',
	'Become franchise': 'Franciza',
	'Select language': 'Selectați limba',
	English: 'Engleză',
	Russian: 'Rusă',
	Azerbaijani: 'Azerbajana',
	Ukrainian: 'Ucraineană',

	Polish: 'Poloneză',
	Management: 'Management',
	'Master Franchise': 'Master-Franciză',
	Franchise: 'Franciză',
	Teachers: 'Învățător',
	Groups: 'Grupa',
	Students: 'Elevi',
	Student: 'Elev',
	Parents: 'Părinți',
	Profile: 'Profil',
	'My profile': 'Profilul meu',
	Finance: 'Finanțe',
	Reports: 'Rapoarte',
	Report: 'Raport',
	Upload: 'Descarcă',
	List: 'Lista',
	Payments: 'Plăți',
	Documents: 'Documente',
	Lessons: 'Lecții',
	Materials: 'Materiale',
	Shop: 'Magazin',
	Statistics: 'Statistica',
	Settings: 'Setări',
	Pages: 'Pagini',
	Logout: 'Ieșire',
	Dashboard: 'Cabinet personal',
	'Access denied': 'Acces interzis',
	Create: 'Creare',
	New: 'Nou',
	Download: 'Încarcare',
	Status: 'Statut',
	'Payment Date': 'Data achitării',
	'Payment Amount': 'Nota de plată',
	'Start time': 'Startul orelor',
	'Group age': 'Vârsta grupei',
	Junior: 'Mică',
	Average: 'Mijlocie',
	Class: 'Clasa',
	Older: 'Mare',
	Region: 'Regiunea',
	Group: 'Grupa',
	Person: 'Specială',
	Finances: 'Finanțe',
	Actions: 'Acțiuni',
	'Send invoice': 'Cont spre plată',
	'Download invoice': ' Descarca contul de plată',
	'Send email': 'Trimite email',
	'Send link': 'Trimite linkul',
	Link: 'Linkul',
	'Create Student': 'Creare student',
	'The beginning of holidays': 'Începerea sarbătorilor',
	'Start of study': 'Începutul studiilor',
	'Group name': 'Denumirea grupei',
	'Group address': 'Adresa grupei',
	'Group teacher': 'Mentorul grupei',
	'Group students': 'Elevii grupei',
	'Group statistics': 'Statistica grupei',
	Search: 'Căutare',
	'General information': 'Informație generală',
	'Phone number': 'Numărul de telefon',
	'First name': 'Prenume',
	Surname: 'Patronimic',
	'Last name': 'Nume',
	'Date of birth': 'Data nașterii',
	Password: 'Parola',
	'Additional information': 'Informație suplimentară ',
	'Id code': 'Id cod',
	Passport: 'Pașaport',
	'Without email newsletter': 'Fără adresă electronică',
	'With email newsletter': 'Cu adresă electronică',
	'Financial information': 'Informația financiară',
	Royalty: 'Royalty',
	'PR contribution': 'PR contribuții',
	Currency: 'Valută',
	Comment: 'Comentarii',
	Paid: 'Achitat',
	Invoices: 'Cont de plată',
	Bills: 'Bancnote',
	Acts: 'Acte',
	Scan: 'Scan',
	Level: 'Nivel',
	'Action with numbers': 'Nr de acțiuni cu numere ',
	'Action with number': 'Numărul de acțiuni',
	'Number of expressions': 'Nr de expresii',
	'Number of expression': 'Numărul de exemple',
	'Imaginary abacus': 'Abac imaginar',
	'Period report': 'Istoricul tranzacțiilor',
	City: 'Oraș',
	'Full name franchise': 'FNP franchise',
	'Students all//blocked/online ': 'Elevi activi',
	'Сost of education': 'Prețul abonamentului',
	'Turnover franchise': 'Cifra de afaceri',
	'Discount sum': 'Suma reducerii',
	Proprietor: 'Proprietar',
	'Additional products and services': 'Produse și servicii suplimentare',
	'Full name student': 'NPP elevului',
	'Period of study': 'Perioada de studii',
	'Bonus-days': 'Zile cu reducere',
	'Amount of days': 'Nr de zile',
	'Total days': 'Total zile',
	'Language of instruction': 'Limba de studiu',
	Teacher: 'Mentor',
	Discount: 'Reduceri',
	Remuneration: 'Remunerare',
	Goods: 'Produse',
	'Date of creation': 'Ziua de start',
	'Date of payment': 'Ziua achitării',
	'Goods (works, services)': 'Produse (lucru,servicii)',
	Quantity: 'Cantitate',
	Units: 'Unităti',
	Amount: 'Total',
	Sum: 'Suma',
	'Sum Sub': 'Adunarea și scădere',
	Financial: 'Financiar',
	Additional: 'Suplimentar',
	General: 'General',
	Total: 'Total',
	Save: 'Salvare',
	'Including with': 'Inclusiv',
	'Training materials': 'Material de lucru',
	'Learning contract': 'Contract',
	Games: 'Jocuri',
	'NUMBER OF 11 TO 120': 'Numere de la 11 pînă la 120',
	Complexity: 'Dificultate',
	Start: 'Start',
	'Speedy numbers': 'Adunare și scădere',
	Anzan: 'Anzan',
	'Abacus is random': 'Abacul Random',
	Multiplication: 'Îmulțire',
	Division: 'Împărțirea',
	Abacus: 'Abac',
	'Multiplying by 20': 'Înmulțirea pînă la 20',
	Squared: 'Ridicarea la pătrat',
	'Division to 20': 'Împărțirea până la 20',
	Speed: 'Viteza',
	Repeat: 'Repetare',
	'Game type': 'ТTipul jocului',
	'Digit type': 'Tipul numerelor',
	Digit: 'Număr',
	Time: 'Timp',
	Oral: 'Imaginar',
	Second: 'Secundă',
	'Calculation method': 'Metoda de calcul',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Doar numere negative începînd cu 99,999,9999 în dependență de dificultatea exemplelor -9,-2,-3,-1',
	'Only subtraction': 'Doar adunarea',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Doar scăderea care începe cu 0.Exemplu +1,+4,+6,+9,+5 ...',
	'Only add': 'Doar  adunarea',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Cifrele întâmplătoare care încep cu 0.Exemplu..+3,-5,-1,+9,-2...',
	'Random numbers': 'Numere întâmplătoare',
	'CHOOSE COMPLEXITY:': 'Alegeți dificultatea:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'Nr de numere și acțiuni',
	FAMILY: 'Familia',
	'BIG FRIENDS': 'prietenii mari',
	'LITTLE FRIENDS': 'Prietenii mici',
	'JUST FRIENDS': 'Prietenii mici',
	'big friends': 'prietenii mari',
	'small friends': 'prietenii mici',
	elementary: 'prietenii simpli',
	family: 'familia',
	Sound: 'Sunet',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Bravo Ești cel mai bun.',
	'RIGHT. ANSWER:': 'Răspuns corect:',
	CORRECT: 'CORECT',
	'NOT CORRECT': 'Incorect',
	'Try again': 'Repetare',
	expression: 'Exemplu',
	next: 'Următorul',
	Next: 'Următorul',
	Previous: 'Precedent',
	Loading: 'Încărcare',
	back: 'În urmă',
	Back: 'În urmă',
	ANSWER: 'Răspuns',
	Lesson: 'LECȚIE',
	'History statistics': 'Istoria statisticii',
	Open: 'Deschis',
	'Game statistics per day': 'Statistica jocului pentru o zi',
	'Total played games': 'Nr de jocuri jucate',
	'Total correct answers': 'Nr de jocuri corecte',
	'Total played:': 'TOTAL JUCAT',
	Feedback: 'Feedback',
	'Leave a review': 'Lasă o recenzie',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Lăsați-ne sugestiile dvs și noi neapărat vom ține cont de ele',
	'Payment history': 'Istoria achitării',
	'Payment status': 'Statutul achitării',
	Pay: 'Achitare',
	Payer: 'Client',
	'Getting a discount': 'A primi reducere',
	Training: 'Antrenament',
	Tasks: 'Sarcini',
	'Current task': 'SARCINI CURENTE',
	'Next tasks': 'SARCINILE URMĂTOARE ',
	'Online abacus': 'Online abac',
	'Base 50/100': 'Baza 50/100',
	multiply_base: 'Baza 50/100',
	divided: 'împărțire',
	'Do not show this instruction again':
		'Mai multnu arătați aceasă instrucțiune',
	'Instructions for homework':
		'Instrucține pentru a efectua tema pentru acasă ',
	divider: 'despărțitor',
	'Multiplication table': 'Tăblița înmulțirii',
	Restore: 'RECUPERARE',
	'left/done': 'Au rămas/ Făcute',
	'Restore Hierarchy': 'Recuperarea informației',
	total: 'total',
	active: 'activi',
	blocked: 'blocați ',
	pageError: {
		'403': '403 Acces interzis',
		'404': '404 pagina nu există..încercați din nou.',
		'500': '500 serveru nu ruspunde ',
	},
	error: {
		'Account deactivated': 'Contul dvs a fost',
	},
	modalNewVersion: {
		text: 'Folosiți versiunea veche',
		btn: 'Actualizați',
	},
	games: {
		negativeNumbers: 'Cifre Negative',
		columns: {
			name: 'Coloane',
			users: 'Nr de jucători',
			user: 'Jucător',
			userNames: 'Numele jucătorului',
		},
	},
	'Indigo-dollars': 'Indigo-dolari',
	Balance: 'Soldul',

	modalIndigoDollars: {
		submit: 'TRIMITE',
		cancel: 'Anulare',
		title: 'Indigo -Dolari',
		balance: 'Soldul curent',
		amount: 'Cantitatea',
		reason: 'Comentarii',
	},
	modalAddNotification: {
		title: 'Adaugă informații',
		submit: 'Trimite',
		cancel: 'Anulare',
		empty: 'nu sunt informații',
	},
	modalTransactionsHistory: {
		title: 'Istoria achitării',
		type: {
			withdraw: 'achitat',
			deposit: 'Adăugare',
		},
		empty: 'Lista achitărilor este goală',
	},
	modalCopyHomework: {
		title: 'copiați tema pentru acasă',
		label: ',Alegeți data la care doriți să copiați tema pentru acasă,',
		submit: 'Copiați',
		cancel: 'Anulare',
	},
	reportsPage: {
		history: {
			title: 'Istoria editărilor',
			empty: 'Lista este goală',
			table: {
				date: 'Data editării',
				field_name: 'Acțiune',
				old_value: 'Denumirea veche ',
				new_value: 'Denumirea nouă',
				user: 'Denumire utilizatorului',
			},
		},
	},

	pageShop: {
		title: 'magazin',
		description:
			'În magazin puteți cumpăra diferite imagini care le puteți vizualiza din propriu cabinet',
		tabs: {
			all: 'Toate produsele',
			purchased: 'Cumpărate',
		},
		item: {
			off_all: 'NU',
			status: {
				AVAILABLE: 'recomendăm',
				DEPRECATED: 'Indisponibil',
				COMING_SOON: 'În timpul apropiat',
			},
			is_activated: 'SELECTAT',
			set_active: 'ALEGEȚI',
			unset_active: 'DECONECTAȚI',
			preview: 'A privi',
			is_free: 'Gratuit',
			buy: 'A cumpăra',
			bought: 'Cumpărat',
			purchased: 'Cumparat',
		},
		empty: {
			all: 'Nu sunt disponibile schimbările ',
			purchased: 'Nu sunt aplicate schimbari',
		},
		toast: {
			error: 'Error Eroare',
			notEnoughMoney: 'Resurse insuficiente ',
			itemBought: 'Schimbari aplicate',
			itemActivated: 'Schimbari activate',
		},
		confirmPurchase: {
			title: 'Confirmă achiziția',
			message: 'Ești sigur că vrei să cumperi acest articol?',
			confirm: 'Da, cumpără',
			cancel: 'Anulează',
		},
	},
	itemDeactivated: 'Schimbari dezactivate',

	demo: {
		title: 'LECȚIE DEMO GRATUITĂ',
		tutorial: {
			title: 'instrucțiune',
			text: 'DESCRIEREA ACȚIUNEI',
		},
	},
}
